<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <qr-edit-gateway
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate(true)"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <view-page
              v-model="data"
              :loading="loading || qrLoading"
              :qr-svg-data-url="qrSvgDataUrl"
            />
          </div>
        </template>
      </qr-edit-gateway>

      <v-row class="pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col class="pa-2" cols="12" md="4" style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <view-page
              v-model="data"
              :loading="loading || qrLoading"
              class="sticky-md"
              style="top: 110px"
              :qr-svg-data-url="qrSvgDataUrl"

            />
          </div>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>اطلاعات</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 2"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام صفحه کاری شما"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام صفحه کاری"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"

                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="آدرس کیوآر "
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
  <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>

                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="e6 = 2"
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                وارد کردن اطلاعات صفحه کاری
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <list-expansion
                  v-model="data"
                  :components="specialInfo2"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <prev-btn :loading="loading" @click="e6 = 1" />
                  </div>

                  <div class="col-md-6">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(true)"
                    />
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrEditGateway from "@/view/pages/qrland/components/QrEditGateway.vue";
import { Bus } from "@/main";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editBpage",

  components: {
    QrCustomize,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    ViewPage,
    QrEditGateway, 
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      AutoSave:false,
      isAutoSaving: false, 
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      serviceName: "Qrland",
      componentName: "editBpage-b",
      helpData: [],
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      loading: false,
      showDialog: false,
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
      qrShow: 1,
      res: {},
      data: {},
      svgMade: "",
      destinationUrl: "",
      qrLoading: false,
    };
  },

  computed: {
    specialInfo() { 
      return [
          {
            name: "bannerSelector",
            value: "",
            title: this.$t("edit_bpage_special_info_special.upload_banner"),
            subtitle: "",
            icon: "image-area",
            model: "banner",
          },
          {
            name: "Service",
            value: "",
            title: this.$t("edit_bpage_special_info_special.services"),
            subtitle: "",
            icon: "toolbox-outline",
            model: "service",
          },
          {
            name: "Faq",
            value: "",
            title: this.$t("edit_bpage_special_info_special.faq"),
            subtitle: "",
            icon: "help",
            model: "faq",
          },
          {
            name: "Blog",
            value: "",
            title: this.$t("edit_bpage_special_info_special.blog"),
            subtitle: "",
            icon: "text",
            model: "blog",
          },
          {
            name: "Product",
            value: "",
            title: this.$t("edit_bpage_special_info_special.create_product"),
            subtitle: "",
            icon: "sign-yield",
            model: "Product",
          },
          {
            name: "textCards",
            value: "",
            title: this.$t("edit_bpage_special_info_special.user_information"),
            subtitle: "",
            icon: "account-outline",
          },
          {
            name: "socialMediaIcons",
            value: "",
            title: this.$t("edit_bpage_special_info_special.add_social_media"),
            subtitle: "",
            icon: "instagram",
            model: "socialMedia",
          },
        ];},

    specialInfo2(){ 
      return [
          {
            name: "PicSelector",
            value: "",
            title: this.$t("edit_bpage_special_info_special.photo_gallery"),
            subtitle: "",
            icon: "image-outline",
            model: "gallery",
          },
          {
            name: "VideoGallery",
            value: "",
            title: this.$t("edit_bpage_special_info_special.video_gallery"),
            subtitle: "",
            icon: "video-outline",
          },
          {
            name: "pdfSelector",
            value: "",
            title: this.$t("edit_bpage_special_info_special.pdf_gallery"),
            subtitle: "",
            icon: "file-outline",
          },
          {
            name: "FeedBack",
            value: "",
            title: this.$t("edit_bpage_special_info_special.feedback"),
            subtitle: "",
            icon: "reply-outline",
            model: "FeedBack",
          },
          {
            name: "consultationNew",
            value: "",
            title: this.$t("edit_bpage_special_info_special.request_form"),
            subtitle: "",
            icon: "list-box-outline",
            model: "consultationNew",
          },
          {
            name: "ServiceSection",
            value: "",
            title: this.$t("edit_bpage_special_info_special.create_section"),
            subtitle: "",
            icon: "post",
            model: "ServiceSection",
          },
          {
            name: "CounterService",
            value: "",
            title: this.$t("edit_bpage_special_info_special.achievements"),
            subtitle: "",
            icon: "bullseye-arrow",
            model: "CounterService",
          },
          {
            name: "Counter",
            value: "",
            title: this.$t("edit_bpage_special_info_special.countdown"),
            subtitle: "",
            icon: "timer-sand",
            model: "Counter",
          },
          {
            name: "Personnel",
            value: "",
            title: this.$t("edit_bpage_special_info_special.team_members"),
            subtitle: "",
            icon: "account-multiple-outline",
            model: "Personnel",
          },
          {
            name: "WorkSheet",
            value: "",
            title: this.$t("edit_bpage_special_info_special.working_hours"),
            subtitle: "",
            icon: "timetable",
            model: "WorkSheet",
          },
        ]},
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    specialInfoSingle() {
      const combined = [
        ...this.specialInfo,
        ...this.specialInfo2,
      ];

      return combined.map((item) => ({
        ...item,
        description:
          item.description ||
          this.$t("editBpage.special_info_single.default_description", {
            title: item.title,
          }),
      }));
    },
  },

  mounted() {
    this.fetchData();

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),

    onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.qrLoading = true;
      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}/${!!this.qrId ? this.qrId : ""}`,
        )
        .then(({ data }) => {
          let input = data.data.data.data;
          this.fixData(input);
          this.setCreatedQrID(data.data.id);
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);
          this.data = input;
          this.res = data.data;
          this.qrSvgDataUrl= data?.data?.img_url||''; 

        })
        .finally(() => (this.qrLoading = false));
    },
    qrUpdate(final = false) {
       if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "Business");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );
      data.append("_method", "PUT");

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if (final || !this.AutoSave)
            this.$toast.success("کیوآر صفحه کاری شما با موفقیت ویرایش شد.");
          if(final)
            this.goto("qr/list");
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    fixData(input) {
      if (!input.banner) {
        input.banner = {
          gallery: null,
        };
      }
      if (!input.pdf) input.pdf = null;
      if (!input.service) input.service = null;
      if (!input.gallery || input.gallery.length === 0)
        input.gallery = [{ name: "گالری عکس", images: [] }];
      if (!input.video_gallery) input.video_gallery = null;
      if (!input.consultationNew)
        input.consultationNew = {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        };
      if (!input.service)
        input.service = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      if (!!input.pdfSelector && !input.pdfSelector.layout) {
        input.pdfSelector = {
          ...input.pdfSelector,
          layout: "list",
        };
      }
      if (!input.blog)
        input.blog = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
